import { useMemo } from "react";
import cx from "classnames";

const TimeRanger = ({ filter, setFilter }) => {
    const optionRanges = useMemo(() => {
        return [
            { label: "7 Days", value: "7" },
            { label: "15 Days", value: "15" },
            { label: "30 Days", value: "30" },
            { label: "90 Days", value: "90" },
            { label: "180 Days", value: "180" },
        ];
    }, []);

    const handleClick = (value) => {
        setFilter((prev) => ({
            ...prev,
            dateRange: value,
        }));
    };

    return (
        <div className="d-flex align-items-center gap-5 flex-wrap">
            <div className="btn-group">
                {optionRanges.map((item) => (
                    <button
                        key={item.value}
                        className={cx("btn btn-outline-info border", {
                            active: (!filter?.dateRange && item.value === "30") || (filter?.dateRange === item.value),
                            "rounded-pill": item.value === "7" || item.value === "180",
                            "rounded-end": item.value === "7",
                            "rounded-start": item.value === "180",
                        })}
                        onClick={() => handleClick(item.value)}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default TimeRanger;
